import { AxiosResponse } from "axios";
import { Payload } from "../interfaces/appAndPayload/Payload.type";
import { ResType } from "../interfaces";
import AxiosRequest from "./api";
import { getCookies, metaDataUTMHandler } from "../helpers/commonFunctions";

const metaDataCookies = metaDataUTMHandler();

const continueFlowUrl = process.env.REACT_APP_PAYMENT_API
  ? `${process.env.REACT_APP_PAYMENT_API}/market-place/continue-flow?${metaDataCookies}`
  : `https:/apiv.sooqdev3.com/v2.1/market-place/continue-flow?${metaDataCookies}`;

export const ContinueDraft = async (
  body: Payload,
  token: string
): Promise<AxiosResponse<ResType>> => {
  return AxiosRequest<ResType>(continueFlowUrl, "POST", body, token);
};
